// src/views/Legal/TermsOfService.js
import React from "react";
import company from "../../config/company";

const TermsOfService = () => {
  const effectiveDate = "12 de octubre de 2026";

  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Términos de Servicio (EULA)
      </h1>

      <p className="mb-4">
        Estos Términos de Servicio (EULA) regulan el uso de las aplicaciones y
        servicios digitales provistos por {company.legalName} ("BBTS"),
        incluida la aplicación {company.products.meso360} en teléfonos,
        tabletas y terminales de pago. Al instalar, acceder o usar nuestras
        soluciones, aceptas estos términos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Licencia y uso permitido
      </h2>
      <p className="mb-4">
        Te otorgamos una licencia limitada, revocable, no exclusiva y no
        transferible para usar la aplicación únicamente para operaciones
        legítimas de tu negocio y conforme a la documentación aplicable.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Restricciones
      </h2>
      <p className="mb-4">
        No podrás copiar, revender, descompilar, alterar o usar la aplicación
        para fines ilegales, fraudulentos o fuera del alcance autorizado.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Datos e integraciones de terceros
      </h2>
      <p className="mb-4">
        Algunas funciones dependen de servicios de terceros, incluyendo Clover y
        Dejavoo/iPOSpays. El uso de dichos servicios también se rige por sus
        términos y políticas. El comercio es responsable de otorgar permisos
        correctos y mantener sus credenciales seguras.
      </p>
      <p className="mb-4">
        BBTS no es un procesador de pagos. Los cobros con tarjeta, sus
        aprobaciones, reembolsos, contracargos, cargos por servicio y depósitos
        los realiza el procesador del comercio (Clover/Fiserv o
        Dejavoo/iPOSpays) según el contrato entre el comercio y ese procesador.
        Ver también nuestros{" "}
        <a className="text-orange-700 underline" href="/disclaimers">
          avisos legales
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Propiedad intelectual
      </h2>
      <p className="mb-4">
        El software, marcas, contenido y documentación asociados a la aplicación
        son propiedad de BBTS o de sus licenciantes y están protegidos por leyes
        aplicables.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Disponibilidad y garantías
      </h2>
      <p className="mb-4">
        La aplicación se ofrece "tal cual" y "según disponibilidad". No
        garantizamos operación ininterrumpida o libre de errores en todo
        momento, aunque aplicamos medidas razonables para continuidad del
        servicio.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Limitación de responsabilidad
      </h2>
      <p className="mb-4">
        En la máxima medida permitida por ley, BBTS no será responsable por
        daños indirectos, incidentales o consecuentes derivados del uso o
        imposibilidad de uso del servicio.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        7. Terminación
      </h2>
      <p className="mb-4">
        Podemos suspender o terminar acceso por incumplimiento de estos términos
        o por razones de seguridad, legales o técnicas.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Ley aplicable y contacto
      </h2>
      <p className="mb-4">
        Estos términos se interpretan conforme a las leyes aplicables en Puerto
        Rico, salvo disposición obligatoria distinta. Para dudas o soporte,
        escríbenos a{" "}
        <a className="text-orange-700 underline" href={`mailto:${company.email}`}>
          {company.email}
        </a>{" "}
        o visita nuestra página de{" "}
        <a className="text-orange-700 underline" href="/contact">
          soporte
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Cambios</h2>
      <p className="mb-4">
        Podemos actualizar estos términos. Publicaremos la versión vigente en
        esta misma página con fecha de actualización.
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Última actualización: {effectiveDate}
      </p>
    </div>
  );
};

export default TermsOfService;
